import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  Character,
  // CharacterFeatureSource,
  CharacterSheetInterface,
  Modifier,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import StringBox from "@components/input/strings/StringBox";
import FloatMenu from "@components/input/menus/FloatMenu";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";

interface Props {
  char: Character;
  char_int: CharacterSheetInterface;
  disabled: boolean;
  // onChange: () => void;
  // onSourceChange: (source: CharacterFeatureSource, do_main: boolean) => void;
}

const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterAC({ 
  char,
  char_int,
  // disabled,
  // onChange,
  // onSourceChange
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [view, setView] = useState("Features");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderACFeatures = () => {
    const ac_features = char_int.modifier_features.filter(cf => 
      cf.floating_feature instanceof Modifier && 
        ["AC"].includes(cf.floating_feature.modifies));
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Armor Class Features
        </Grid>
        { ac_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = char_int instanceof Character ? char_int.all_char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id) : null;
          if (source) {
            return (
              <Grid
                key={key}
                size={{
                  xs: 12
                }}>
                <CharacterFeatureFromSource
                  character={char}
                  obj={char_feature}
                  source={source}
                />
              </Grid>
            );
          }
          return null;
        })}
      </>
    );
  }

  const renderACCustomizations = () => {
    return (
      <>
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          { view }
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          Current AC: { char_int.armor_class }
        </Grid>
        { renderACCustomization("Modifier") }
        { renderACCustomization("Override") }
      </>
    );
  }

  const renderACCustomization = (customization_type: string) => {
    const customization = char_int.AC_customization.AC[customization_type];
    return (
      <>
        <Grid
          size={{
            xs: 4
          }}>
          { customization_type }
        </Grid>
        <Grid
          size={{
            xs: customization && customization.value !== null ? 4 : 8
          }}>
          <StringBox
            name="Value"
            value={ customization && customization.value !== null ? `${customization.value}` : "" }
            onBlur={(changed: string) => {
              if (!char_int.AC_customization.AC[customization_type]) {
                char_int.AC_customization.AC[customization_type] = { value: null, notes: "" };
              }
              if (changed === "") {
                delete char_int.AC_customization.AC[customization_type];
              } else {
                char_int.AC_customization.AC[customization_type].value = +changed;
              }
              char.changed();
              console.log("AC Change");
              console.log(char);
              char_util.repopulateCharFeatureBases(char);
              setReloading(true);
            }}
          />
        </Grid>
        { customization && customization.value !== null &&
          <Grid
            size={{
              xs: 4
            }}>
            <StringBox
              name={ `Source/Notes` }
              value={ customization ? customization.notes : "" }
              onBlur={(changed: string) => {
                if (!char_int.AC_customization.AC[customization_type]) {
                  char_int.AC_customization.AC[customization_type] = { value: null, notes: "" };
                }
                char_int.AC_customization.AC[customization_type].notes = changed;
                console.log("AC Change");
                console.log(char);
                setReloading(true);
              }}
            />
          </Grid>
        }
      </>
    );
  }

  const renderView = () => {
    switch(view) {
      // case "Current": return renderCurrent();
      case "Features": return renderACFeatures();
      // case "Bonus Proficiencies": return renderBonusACProfs();
      default: return renderACCustomizations();
    }
  }

  const options = ["Features","Customize"];
  return (
    <Grid
      container
      spacing={0}
      direction="row"
      size={{
        xs: 12
      }}>
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        Manage Armor Class
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <FloatMenu
          options={options}
          selected={view}
          onSelect={setView}
        />
      </Grid>
      { renderView() }
    </Grid>
  );
}
